<template>
  <section id="chat" class="chat-component page-section">
    <div class="container">
      <header class="main-title title">Chat</header>
      <div v-if="!logged" class="login-container">
        <div class="login-input-container">
          <input
              v-model="userName"
              @keyup="validateEnterKey($event, 'login')"
              placeholder="Please, enter your name">
          <button @click="addUser">Login</button>
        </div>
      </div>
      <div v-if="logged" class="chat-container">
        <div class="chat-messages-and-users">
          <div class="chat-messages">
            <div v-for="(message, index) in messages" :key="index" class="one-message"
                 :class="[{'new-one': message.type === 'user-joined'}, {'leave-one': message.type === 'user-left'}]">
              <div class="username">{{ message.userName }}:</div>
              <div class="message">{{ message.message }}</div>
            </div>
          </div>
          <div class="users">
            <div class="my-user">
              <div class="name myEllipsis" :title="userName">{{ userName }}</div>
              <div @click="logout" class="logout">Logout</div>
            </div>
            <div class="users-list">
              <div v-for="(user, index) in displayUsers" :key="index" class="one-user">
                <div class="name myEllipsis" :title="user.userName">{{ user.userName }}</div>
                <div v-if="user.typing" class="typing">typing...</div>
              </div>
            </div>
          </div>
        </div>
        <div class="chat-input">
          <input
              v-model="currentMessage"
              @blur="typing(false)"
              @focus="typing(true)"
              @keyup="validateEnterKey($event, 'new message')">
          <div class="send-message-button" @click="addNewMessage">Send</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import io from 'socket.io-client';

export default {
  name: "ChatComponent",
  data() {
    return {
      socket: null,
      logged: false,
      userName: '',
      users: [],
      messages: [],
      currentMessage: '',
    }
  },
  created() {
    this.socketOn();
  },
  beforeDestroy() {
    this.socket.disconnect();
  },
  computed: {
    displayUsers() {
      return this.users.filter(user => {
        return user.userName !== this.userName;
      });
    }
  },
  methods: {
    socketOn() {
      this.socket = io(document.location.protocol + '//' + document.location.hostname);
      this.socket.on('connect', () => {
      });
      this.socket.on('login', (data) => {
        this.logged = true;
        this.userName = data.userName;
        this.users = data.users;
      });
      this.socket.on('user-joined', (data) => {
        this.users = data.users;
        this.messages.push({
          userName: data.userName,
          type: data.type,
          message: 'joined to chat!!!'
        })
      });
      this.socket.on('new message', (data) => {
        this.messages.push(data);
      });
      this.socket.on('user-left', (data) => {
        this.users = data.users;
        this.messages.push({
          userName: data.userName,
          type: data.type,
          message: 'leave chat!!!'
        })
      });
      this.socket.on('typing', (data) => {
        this.users = data.users;
      });
      this.socket.on('stop-typing', (data) => {
        this.users = data.users;
      });
    },
    addUser() {
      if (!this.socket.connected) {
        this.socket.connect();
      }
      this.socket.emit('add-user', this.userName);
    },
    addNewMessage() {
      this.socket.emit('new message', this.currentMessage);
      this.messages.push({
        userName: this.userName,
        message: this.currentMessage
      });
      this.currentMessage = '';
    },
    validateEnterKey(event, from) {
      if (event.keyCode === 13) {
        event.target.blur();

        switch (from) {
          case 'login':
            this.addUser();
            break;
          case 'new message':
            this.addNewMessage();
            break;
          default:
        }
      }
    },
    typing(typing) {
      if (typing) {
        this.socket.emit('typing', this.userName);
      } else {
        this.socket.emit('stop-typing', this.userName);
      }
    },
    logout() {
      this.userName = '';
      this.logged = false;
      this.socket.disconnect();
    }
  }
}
</script>

<style lang="scss" scoped>
#chat.chat-component {
  background-color: #ffffff;
  width: 100%;

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    .login-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;


      .login-input-container {
        display: flex;
        align-items: center;
        justify-content: center;

        input {
          height: 30px;
          margin: 0 5px;
          padding-inline-start: 5px;
        }

        button {
          height: 30px;
          margin: 0 5px;
        }
      }


    }

    .chat-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .chat-messages-and-users {
        display: flex;
        height: 22vh;
        //min-width: 500px;
        width: 65%;

        .chat-messages {
          height: 100%;
          width: 70%;
          overflow-x: auto;
          background-color: #f5f5f5;

          .one-message {
            display: flex;
            align-items: baseline;
            justify-content: flex-start;

            .username {
              padding: 5px;
              font-style: italic;
              font-size: 14px;
              font-weight: bold;
            }

            .message {
              padding: 5px;
            }

            &:nth-child(even) {
              background-color: #fbfbfb;
            }

            &.new-one {
              font-style: italic;
              background-color: #d5f5c5;

              .username, .message {
                font-size: 13px;
              }
            }

            &.leave-one {
              font-style: italic;
              background-color: #ffcfcf;

              .username, .message {
                font-size: 13px;
              }
            }
          }
        }

        .users {
          height: 100%;
          width: 30%;
          background-color: #ececec;
          border-inline-start: 1px solid #dadada;

          .users-list {
            height: calc(100% - 30px);
            overflow-y: auto;
          }

          .my-user, .one-user {
            height: 30px;
            display: flex;
            align-items: center;
            padding: 0 10px;
            justify-content: space-between;

            .name {
              width: calc(100% - 52px);
            }

            .typing {
              font-size: 13px;
              font-style: italic;
            }

            .logout {
              width: 52px;

              &:hover {
                cursor: pointer;
                font-weight: bold;
              }
            }
          }

          .my-user {
            background-color: #f5f5f5;
          }
        }
      }

      .chat-input {
        width: 65%;
        display: flex;
        align-items: center;

        input {
          width: 100%;
          height: 30px;
          margin: 15px 0;
          padding-inline-start: 5px;
        }

        .send-message-button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100px;
          height: 30px;
          background-color: #ececec;
          font-weight: bold;

          &:hover {
            cursor: pointer;
            box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
          }
        }
      }
    }
  }
}


/*media*/
@media screen and (max-width: 1200px) {
  #chat.chat-component .container .chat-container {
    .chat-messages-and-users {
      width: 100%;
    }

    .chat-input {
      width: 100%;
    }
  }
}

@media screen and (max-width: 1000px) {
}

@media screen and (max-width: 770px) {
}
</style>